import React, { useState } from 'react';

import Button from 'shared/button';
import Modal from './modal';
import PropertyImportModal from 'bundles/crm/imports/properties';
import { retrieveRecords } from 'bundles/research/index/store/actions/search.js';
import { useDispatch } from 'bundles/research/index/store/hooks';

import type { DromoImporterProps } from 'components/dromo/types';

import './styles.scss';

interface NewPropertyButtonProps {
  dromoImporterProps: DromoImporterProps,
  edgeCrm: boolean;
  insights: boolean;
  newPropertyPath: string;
}

export default function NewPropertyButton({
  dromoImporterProps,
  edgeCrm,
  insights,
  newPropertyPath,
}: NewPropertyButtonProps) {
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [showImportsModal, setShowImportsModal] = useState<boolean>(false);

  if (!edgeCrm || !insights) {
    return (
      <Button.Primary className="new-property-button" href={newPropertyPath}>
        New Property
      </Button.Primary>
    );
  }

  const menuItems = [
    { label: 'New Property', onClick: () => setShowCreateModal(true) },
    { label: 'Import Properties', onClick: () => setShowImportsModal(true) },
  ];

  const dispatch = useDispatch();
  const hideImportModal = (refresh) => {
    if (refresh) {
      dispatch(retrieveRecords());
    }
    setShowImportsModal(false);
  };

  return (
    <React.Fragment>
      <Button.Primary
        className="new-property-button"
        dropdownMenuItems={menuItems}
        dropdownMenuRightAligned
        label="New Property"
      />
      <Modal
        newPropertyPath={newPropertyPath}
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
      />
      <PropertyImportModal
        dromoImporterProps={dromoImporterProps}
        show={showImportsModal}
        onHide={hideImportModal}
      />
    </React.Fragment>
  );
}
